import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getPrices(id, filter) {
	const {data} = await axios.get(`/doctor-prices`, {params: filter});

	return data;
}

export function usePrices(hospitalId) {
	const [filterPrices, setFilterPrices] = useState({
		hospitalId,
		page: 1,
		search: null,
		limit: 10,
	});
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["doctor-prices", hospitalId, filterPrices], async () => getPrices(null, filterPrices));

	return {data, isLoading, isError, error, filterPrices, setFilterPrices};
}

export const fetchPriceByID = priceId => {
	return axios.get(`/doctor-prices/${priceId}`).then(res => res.data);
};

export function useDetailPrice(priceId) {
	return useQuery({
		queryKey: priceId && ["doctor-prices", priceId],
		queryFn: key => fetchPriceByID(priceId),
		refetchOnMount: true,
		refetchOnWindowFocus: true,
		enabled: !!priceId,
	});
}
